export default {"src":"/_next/static/media/person1.bb23570f.svg","height":75,"width":75};